function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4ZM12.4166 17.3126L14.6912 15.9994L12.4191 14.6876L9.50616 15.4681L9.11793 14.0192L10.582 13.6269L8.88925 12.6496L9.63925 11.3506L11.3334 12.3287L10.9405 10.8624L12.3894 10.4741L13.1706 13.3894L15.44 14.6997V12.0754L13.3068 9.94209L14.3674 8.88143L15.44 9.95405V8H16.94V9.95405L18.0127 8.88143L19.0733 9.94209L16.94 12.0754V14.701L18.8082 13.6224L19.5887 10.7094L21.0376 11.0976L20.6453 12.5617L22.7431 11.3506L23.4931 12.6496L21.3939 13.8616L22.8602 14.2545L22.472 15.7034L19.5568 14.9223L17.6912 15.9994L19.5593 17.0779L22.4745 16.2967L22.8628 17.7456L21.3964 18.1385L23.4957 19.3506L22.7457 20.6496L20.6479 19.4385L21.0402 20.9025L19.5913 21.2907L18.8108 18.3778L16.94 17.2977V19.454L19.0733 21.5873L18.0127 22.648L16.94 21.5754V24H15.44V21.5754L14.3674 22.648L13.3068 21.5873L15.44 19.454V17.2991L13.168 18.6108L12.3869 21.526L10.938 21.1378L11.3309 19.6715L9.63672 20.6496L8.88672 19.3506L10.5795 18.3732L9.1154 17.9809L9.50363 16.532L12.4166 17.3126Z",
  fill: "#2F66E3"
});

var SvgFrozen = function SvgFrozen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFrozen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/frozen.f19e8fd5.svg";
export { ForwardRef as ReactComponent };